import React from 'react';

function SelectableOption({ option, isSelected, onClick, disabled }) {
    const handleClick = () => {
        if (!disabled) {
            onClick(option.value);
        }
    };

    const handleKeyPress = (event) => {
        if (!disabled && (event.key === 'Enter' || event.key === ' ')) {
            onClick(option.value);
        }
    };

    return (
        <div
            className={`question-option ${isSelected ? 'selected' : ''}${disabled ? ' disabled' : ''}`}
            onClick={handleClick}
            onKeyPress={handleKeyPress}
            role="button"
            tabIndex={0}
            aria-pressed={isSelected}
            aria-disabled={disabled}
            data-value={option.value}
            style={disabled ? { pointerEvents: 'none', opacity: 0.5 } : {}}
        >
            {option.icon && <span className="option-icon">{option.icon}</span>}
            <span className="option-text">{option.text}</span>
        </div>
    );
}

export default SelectableOption;